import { render, staticRenderFns } from "./AddOrUpdateEmail.vue?vue&type=template&id=42b98249&scoped=true&"
import script from "./AddOrUpdateEmail.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateEmail.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateEmail.vue?vue&type=style&index=0&id=42b98249&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b98249",
  null
  
)

export default component.exports